import { z } from 'zod';

export type AddWalletResponse = {
	id: number;
	balance: number;
	currency: string;
};

export const addWalletResponseSchema: z.ZodType<AddWalletResponse> = z.object({
	id: z.number(),
	balance: z.number(),
	currency: z.string(),
});
